import React from "react";
import classNames from "classnames";
import "./Forms.scss";

interface FormItem {
    colspan?: number;
}

export const FormItem: React.FC<FormItem> = ({children, colspan}) => {
    const classes = classNames({
        "form__item": true,
        "form__item_span-1": colspan === 1,
        "form__item_span-2": colspan === 2,
        "form__item_span-3": colspan === 3,
    });

    return (
        <div className={classes}>
            {children}
        </div>
    );
};